import DiplomaButton from './DiplomaButton';

export default DiplomaButton;
